import { createFileRoute } from '@tanstack/react-router'
import { OperationsCampaignsPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/campaigns/')({
  component: OperationsCampaignsPage,
  beforeLoad: requireRole(['admin']),
})
